import * as React from "react";

function SvgTemperature(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.727 19.55a2.5 2.5 0 00-2.5-2.5h-.454a2.5 2.5 0 00-2.5 2.5v9.18a5.455 5.455 0 105.455 0v-9.18zm-4.09 5.61c0-.691.559-1.25 1.25-1.25h.227c.69 0 1.25.559 1.25 1.25v4.436A4.093 4.093 0 0128 37.546a4.091 4.091 0 01-1.364-7.95V25.16z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 15.5a2.5 2.5 0 012.5-2.5h25a2.5 2.5 0 012.5 2.5v25a2.5 2.5 0 01-2.5 2.5h-25a2.5 2.5 0 01-2.5-2.5v-25zm14.66.227a3.75 3.75 0 00-3.75 3.75V28a6.818 6.818 0 108.182 0v-8.523a3.75 3.75 0 00-3.751-3.75h-.682zm7.783 2.727a.625.625 0 00-.625.625v.114c0 .345.28.625.625.625h4.205c.345 0 .625-.28.625-.625v-.114a.625.625 0 00-.625-.625h-4.205zm-.625 4.716c0-.345.28-.625.625-.625h2.841c.345 0 .625.28.625.625v.114c0 .345-.28.625-.625.625h-2.84a.625.625 0 01-.626-.625v-.113zm.625 3.466a.625.625 0 00-.625.625v.114c0 .345.28.625.625.625h4.205c.345 0 .625-.28.625-.625v-.114a.625.625 0 00-.625-.625h-4.205z"
        fill="#fff"
      />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgTemperature;
